import { ENV_CONFIG } from 'config/environment';

const baseImgUrl = `${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/getstarted`;

export const getStartedItemsBackup = [
  {
    id: 1,
    title: 'Data-Driven Strategy',
    subtitle:
      'Oath makes smart recommendations backed by proven results and decades of experience.',
    image: 'image_measureimpact',
  },
  {
    id: 2,
    title: 'No Platform Fee',
    subtitle:
      'We don’t charge a platform fee and we have among the lowest credit card processing fees in the industry.',
    image: 'image_free',
  },
  {
    id: 3,
    title: 'Zero Spam',
    subtitle:
      'Oath never sells or shares your data. That means less of those annoying texts and emails.',
    video: 'video_zerospam',
  },
];

export const getStartedItems = [
  {
    id: 1,
    title: 'Zero Spam',
    subtitle:
      'Oath never sells or shares your data. That means less of those annoying texts and emails.',
    image: 'image_measureimpact',
  },
  {
    id: 2,
    title: 'No Platform Fee',
    subtitle:
      'We don’t charge a platform fee and we have among the lowest credit card processing fees in the industry.',
    image: 'image_free',
  },
  {
    id: 3,
    title: 'Measurable Impact',
    subtitle:
      'Oath makes data-driven donation recommendations and helps track your impact in every race.',
    video: 'video_zerospam',
  },
];

export const ourImpactItems = [
  {
    id: 1,
    title: '1,000+',
    subtitle:
      'Thousands of candidates - ranging from school board to US Senate - have received Oath donor support',
    image: '',
  },
  {
    id: 2,
    title: '67%+',
    subtitle:
      'More than 67% of all donations directed to a competitive election decided by less than 5% margin ',
    image: '',
  },
  {
    id: 3,
    title: '$10M+',
    subtitle: 'More than $10M+ has been directed to critical US House races already this cycle',
    image: '',
  },
];

export const ourImpactCards = [
  {
    label: 'Federal',
    image: `${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/getstarted/stat_1.png`,
    headline:
      "Delivered double digit boost to flip the House in the midterms and <strong>block Trump's agenda</strong>",
    body: 'The Oath community is the largest funder of flippable House races outside the Democratic party. In Q1 candidates got up to 50% of their funding through Oath.',
    stats: [
      { value: '3', label: 'seats to flip' },
      { value: '35%+', label: 'of funding coming from Oath' },
    ],
  },
  {
    label: 'State Legislatures',
    image: `${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/getstarted/stat_2.png`,
    headline:
      '<strong>Broke the Republican super majority in North Carolina</strong> by supporting candidates like Dante Pittman',
    body: 'One race in NC helped restore veto power to the Democratic Governor. It came down to just 870 votes and may have ended differently if not for hundreds of thousands of dollars from Oath donors.',
    stats: [
      { value: '870', label: 'Vote Margin' },
      { value: '30%', label: 'Of Donors from Oath' },
    ],
  },
];

export const quotes = [
  {
    title: 'No spam, ever!',
    description:
      'SO grateful to Oath for not adding me to new lists when I donate through your platform!',
    author: 'Ryan',
    location: 'New York',
    photo: `${baseImgUrl}/ryan.png`,
  },
  {
    title: 'Donate where it matters most',
    description:
      'Oath was an essential partner for us in 2024, and the support of grassroots donors like yours formed the backbone of our campaign.',
    author: 'Christina Bohannan',
    location: 'Running for US House IA-01',
    photo: `${baseImgUrl}/christina.png`,
  },
  {
    title: 'Smart and simple',
    description:
      'I LOVE the whole concept of Oath. You’ve gotten me off the whole treadmill, rat race of political donations and the stress of trying to pick what makes a difference.',
    author: 'Liz',
    location: 'Wisconsin',
    photo: `${baseImgUrl}/liz.png`,
  },
];
